<template>

  <div class="d_flex flex_direction_col">
    <div class="nav_w">
      <!-- 导航头 -->
      <div
        ref="navHead"
        class="nav_head"
        :class="isActiveTab ? 'is_fixed' : ''"
      >

        <ul class="d_flex fz16 c_1A1A1A">
          <li @click="onTabAnchor('firstTab')">
            <el-button
              :class="firstActive ? 'is_active' : ''"
            >项目信息</el-button>
          </li>

          <li v-if="hasOtherAttachs" @click="onTabAnchor('secondTab')">
            <el-button
              :class="secondActive ? 'is_active' : ''"
            >相关附件</el-button>
          </li>

          <li
            v-if="hasVideos"
            @click="onTabAnchor('thirdTab')"
          >
            <el-button
              :class="thirdActive ? 'is_active' : ''"
            >标的视频</el-button>
          </li>

          <li @click="onTabAnchor('fourthTab')">
            <el-button
              :class="fourthActive ? 'is_active' : ''"
            >交易须知</el-button>
          </li>

          <li v-if="hasLocation" @click="onTabAnchor('fifthTab')">
            <el-button
              :class="fifthActive ? 'is_active' : ''"
            >标的位置</el-button>
          </li>

          <li @click="onTabAnchor('sixthTab')">
            <el-button
              :class="sixthActive ? 'is_active' : ''"
              class="record_btn"
            >出价记录（<em
              class="bids_num"
              :class="sixthActive ? 'c_fff' : 'c_0983CC'"
            >{{ itemDetail.biddings.length }}</em>）</el-button>
          </li>
        </ul>
      </div>

    </div>

    <div
      class="tab_content_w"
      :style="{
        'padding-top': isActiveTab ? navHeadHeight + 'px' : 0,
      }"
    >

      <!-- 项目信息 -->
      <div
        v-if="initComplete"
        ref="firstTab"
        class="tab_w text_center"
      >

        <div class="title_w x_y_center c_1A1A1A font_w_bold">
          <span class="line" /><span>标的介绍</span><span class="line" />
        </div>

        <div class="targets_w fz14 c_1A1A1A d_flex flex_direction_col">

          <!-- 项目信息 -->
          <!-- <proInfo :data="itemDetail" /> -->
          <table border="0" cellspacing="10">
            <tr>
              <!-- 注意该rowspan="" -->
              <td rowspan="15" class="table_title" style="width: 85px">项目信息</td>
              <td class="w_td font_w_bold">项目名称</td>
              <td class="max_w_107 text_left">
                {{ projectInfo.title }}
              </td>
              <td class="w_td font_w_bold">项目编号</td>
              <td class="max_w_107 text_left">{{ projectInfo.projectNo }}</td>
            </tr>

            <tr>
              <td class="font_w_bold">交易方式</td>
              <td class="max_w_107 text_left">
                {{ tradeModeKey[projectInfo.tradeMode] }}
              </td>
              <td class="font_w_bold">转出方式</td>
              <td class="max_w_107 text_left">
                {{ projectInfo.transferModeName }}
              </td>
            </tr>

            <tr>
              <td class="font_w_bold">转出期限</td>
              <td class="max_w_107 text_left">{{ projectInfo.deadline }} 年</td>
              <td class="font_w_bold">价格</td>
              <td class="max_w_107 text_left">{{ projectInfo.price }}{{ projectInfo.priceUnitDesc }}<span v-if="itemDetail.priceUnit === 'zongjia'"
                >({{ priceUnitKey[itemDetail.priceUnit] }})</span
              >
              </td>
            </tr>

            <tr v-if="projectInfo.targets[0].typeName">
              <td class="font_w_bold">标的类型</td>
              <td colspan="3" class="text_left">
                {{ projectInfo.targets[0].typeName  }}
              </td>
            </tr>

            <tr v-if="itemDetail.projectStartAt">
              <td class="font_w_bold">预计租赁起始日期</td>
              <td colspan="3" class="text_left">
                <span>{{
                  formatDate(itemDetail.projectStartAt, "yyyy-MM-dd")
                }}</span>
                <span v-show="itemDetail.projectEndAt"> 至 </span>
                <span v-if="itemDetail.projectEndAt">{{
                  formatDate(itemDetail.projectEndAt, "yyyy-MM-dd")
                }}</span>
              </td>
            </tr>

            <tr>
              <td class="font_w_bold">所在区域</td>
              <td colspan="3" class="text_left">{{ projectInfo.area }}</td>
            </tr>

            <tr>
              <td class="font_w_bold">详细地址</td>
              <td colspan="3" class="text_left" :title="projectInfo.address">
                {{ projectInfo.address }}
              </td>
            </tr>

            <tr>
              <td class="font_w_bold">数量/面积</td>
              <td class="max_w_107 text_left">
                {{ projectInfo.quantity
                }}{{ projectInfo.quantityUnitName }}
              </td>
              <td class="font_w_bold">付款方式</td>
              <td class="max_w_107 text_left">
                {{ paymentModeKey[projectInfo.paymentMode] }}
              </td>
            </tr>

            <tr>
              <td class="font_w_bold">评估价格</td>
              <td class="max_w_107 text_left">
                {{ projectInfo.evaluated.evaluatePrice }}元
              </td>
              <td class="font_w_bold">评估机构</td>
              <td class="max_w_107 text_left">
                {{ projectInfo.evaluated.organ }}
              </td>
            </tr>

            <tr>
              <td class="font_w_bold">项目延期</td>
              <td colspan="3" class="text_left">
                {{ delayKey[itemDetail.auctionDelay] }}
              </td>
            </tr>

            <tr>
              <td class="font_w_bold">用 途</td>
              <td colspan="3" class="text_left">
                {{ projectInfo.purpose }}
              </td>
            </tr>
            <!-- <tr>
              <td class="font_w_bold">其他说明</td>
              <td colspan="3" class="text_left">
                {{ projectInfo.remark }}
              </td>
            </tr> -->
          </table>

          <!-- 标的信息 -->
          <!-- <targetInfo :data="projectInfo" /> -->
          <table
            v-if="projectInfo.targets && projectInfo.targets.length"
            border="0"
            cellspacing="10"
          >
            <tr>
              <td rowspan="20" class="table_title" style="width: 85px">标的信息</td>
            </tr>

            <component :is="projectInfo.tradeKind" :item-detail="projectInfo" />
          </table>

          <!-- 竞价规则 -->
          <!-- <auction :data="itemDetail" /> -->
          <table border="0" cellspacing="10" >
            <tr>
              <td rowspan="20" class="table_title" style="width: 85px">竞价规则</td>
              <td class="w_td font_w_bold">是否缴纳交易保证金</td>
              <td class="max_w_107 text_left">
                {{ whether[itemDetail.deposit] }}
              </td>
              <td class="w_td font_w_bold">交易保证金</td>
              <td class="max_w_107 text_left">{{ itemDetail.margin || 0 }}元</td>
            </tr>

            <tr>
              <td class="font_w_bold">竞价方式</td>
              <td class="max_w_107 text_left">
                {{ auctionModeKey[itemDetail.auctionMode] }}
              </td>
              <td class="font_w_bold">竞价幅度</td>
              <td class="max_w_107 text_left">
                {{ itemDetail.auctionRange || 0 }}元
              </td>
            </tr>

            <tr>
              <td class="font_w_bold">出价次数</td>
              <td class="max_w_107 text_left">
                {{ bidCountKey[itemDetail.bidCount] }}
              </td>
              <td class="font_w_bold">竞价方向</td>
              <td class="max_w_107 text_left">
                {{ directionKey[itemDetail.direction] }}
              </td>
            </tr>

            <tr>
              <td class="font_w_bold">是否延时</td>
              <td class="max_w_107 text_left">
                {{ whether[itemDetail.delay] }}
              </td>
              <td class="font_w_bold">延时周期</td>
              <td class="max_w_107 text_left">
                {{ itemDetail.delayedMinute }}分钟/次
              </td>
            </tr>

            <tr>
              <td class="font_w_bold">报名延期</td>
              <td colspan="3" class="text_left" >{{delayKey[itemDetail.auctionDelay]}}</td>
            </tr>

            <tr>
              <td class="font_w_bold">报名开始时间</td>
              <td class="max_w_107 text_left">
                {{ itemDetail.applyStartTime }}
              </td>
              <td class="font_w_bold">报名结束时间</td>
              <td class="max_w_107 text_left">
                {{ itemDetail.applyEndTime }}
              </td>
            </tr>

            <tr>
              <td class="font_w_bold">竞价开始时间</td>
              <td class="max_w_107 text_left">
                {{ itemDetail.auctionStartTime }}
              </td>
              <td class="font_w_bold">竞价结束时间</td>
              <td class="max_w_107 text_left">
                {{ itemDetail.auctionEndTime }}
              </td>
            </tr>
          </table>

          <!-- 账户信息 -->
          <!-- <bankInfo :data="itemDetail" /> -->
          <table v-if="itemDetail.bankCard" border="0" cellspacing="10">
            <tr>
              <td rowspan="5" class="table_title" style="width: 85px">账户信息</td>
              <td class="w_td font_w_bold">账户名称</td>
              <td class="text_left">
                {{ itemDetail.bankCard.accountName }}
              </td>
            </tr>

            <tr>
              <td class="font_w_bold">开 户 行</td>
              <td class="text_left">
                {{ itemDetail.bankCard.openBank }}
              </td>
            </tr>

            <tr>
              <td class="font_w_bold">银行账号</td>
              <td class="text_left">
                {{ itemDetail.bankCard.bankCard }}
              </td>
            </tr>

            <!-- <tr>
              <td class="font_w_bold">其他说明</td>
              <td class="text_left">保证金打款时注明项目编号</td>
            </tr> -->
          </table>

        </div>

        <!-- 实景图 -->
        <!-- <realisticImg :picture-list="projectInfo.realisticImgs" /> -->
        <div
          v-if="projectInfo.realisticImgs.length"
          id="_realisticImgs"
          class="realistic_picture_w d_flex flex_wrap text_center"
        >
          <el-image
            v-for="(item, index) in projectInfo.realisticImgs"
            :key="index"
            class="pic_i"
            :src="item + '!443'"
            alt=""
            :preview-src-list="projectInfo.realisticImgs"
          />

        </div>
      </div>

      <!-- 相关附件 -->
      <div
        v-if="hasOtherAttachs"
        ref="secondTab"
        class="second_tab tab_w text_center"
      >
        <div class="title_w x_y_center c_1A1A1A font_w_bold">
          <span class="line" /><span>相关附件</span><span class="line" />
        </div>

        <div v-if="allOtherAttachs.length" class=" fz14">
          <div v-for="(item, index) in allOtherAttachs" :key="index" class="attachs_item text_left">
            <span>附件{{ index + 1 }}：</span>
            <span
              class="cursor_pointer c_2CAEFF"
              @click="
                openPreviewFile({
                  file: {
                    url: item.url,
                    name: item.name,
                  },
                  bucket: Bucket_pub,
                  url: '/user/sts/public',
                })
              "
              >{{ item.name }}
            </span>
          </div>
        </div>
      </div>

      <!-- 标的视频 -->
      <div
        v-if="hasVideos"
        ref="thirdTab"
        id="thirdTab"
        class="tab_w text_center"
      >
        <div class="title_w x_y_center c_1A1A1A font_w_bold">
          <span class="line" /><span>标的视频</span><span class="line" />
        </div>

        <div
          class="text_center video_i"
          v-for="(item, index) in projectInfo.videos"
          :key="index"
          :style="{
            background: `url('${item.cover}') center 0 no-repeat rgb(0,0,0)`,
          }"
          @mouseenter="onTargetVideoEnter(index)"
          @mouseleave="onTargetVideoLeave"
        >
          <div
            :id="'targetVideo_' + index"
            v-show="player && playVideoIndex === index"
          ></div>

          <img
            @click="onPlayVideoClick('play', index)"
            v-show="
              currentVideoIndex === index && playVideoIndex !== currentVideoIndex
            "
            class="video_i_play_btn"
            src="@/assets/images/play.png"
            alt=""
          />

          <img
            @click="onPlayVideoClick('pause', index)"
            v-show="
              targetVideoCheck === 'play' &&
              playVideoIndex !== null &&
              currentVideoIndex === index &&
              playVideoIndex === index
            "
            class="video_i_play_btn"
            src="@/assets/images/pause.png"
            alt=""
          />
        </div>
      </div>

      <!-- 竞买须知 -->
      <div
        id="_read"
        ref="fourthTab"
        class="tab_w"
      >
        <div class="title_w x_y_center c_1A1A1A font_w_bold">
          <span class="line" /><span>交易须知</span><span class="line" />
        </div>
        <div class="tab_c_w">
          <div v-if="bidding" class="fz14" v-html="bidding.content" />
        </div>
      </div>

      <!-- 标的位置 -->
      <div
        ref="fifthTab"
        class="tab_w"
        id="fifthTab"
        v-if="hasLocation"
      >
        <div class="title_w x_y_center c_1A1A1A font_w_bold">
          <span class="line" /><span>标的位置</span><span class="line" />
        </div>

        <div class="tab_c_w">
          <p class="text_center fz12" style="color: #e82c2c; margin: 0 0 20px 0">
            地图标注仅供参考，具体位置以标的物实际为准
          </p>

          <div class="map_w">
            <div class="map_options">
              <el-radio-group v-model="tMapType" size="small">
                <el-radio-button label="Satellite">卫星</el-radio-button>
                <el-radio-button label="Normal">地图</el-radio-button>
              </el-radio-group>
            </div>

            <!-- leaflet地图 -->
            <div id="lMap" style="width: 100%; height: 700px" />

            <!-- 天地图实例 -->
            <div id="tMap" />
          </div>
        </div>
        <!-- 按需引入js资源 -->
        <ImportJs
          :src="`${static_resource}/js/tianditu.js`"
          script-key="tianditu"
        />
        <ImportJs
          :src="`${static_resource}/leaflet/js/leaflet.js`"
          script-key="leaflet"
          @loadComplete="leafletLoadComplete"
        />
        <ImportJs
          :src="`${static_resource}/leaflet/js/leaflet-geoman.js`"
          script-key="leaflet-geoman"
        />
        <ImportJs
          :src="`${static_resource}/js/turf.js`"
          script-key="turf"
          @loadComplete="mapJsCompleteFn"
        />
      </div>

      <!-- 出价记录 -->
      <div
        id="_bid"
        ref="sixthTab"
        class="tab_w"
      >
        <div class="title_w x_y_center c_1A1A1A font_w_bold">
          <span class="line" /><span>出价记录</span><span class="line" />
        </div>

        <div class="tab_c_w">
          <div class=" letter_spacing_1" style="margin-top:20px">
            <div class=" bc_F2F2F2 c_808080 d_flex text_center fz16" style="padding:17px 0">
              <div  style="width:200px">状态</div>
              <div  style="width:300px">竞买方</div>
              <div  style="width:315px">价格</div>
              <div  style="width:362px">出价时间</div>
            </div>

            <div v-if="itemDetail">
              <div
                v-for="(item, index) in itemDetail.biddings"
                :key="item.id"
                class="biddings_w d_flex text_center fz14"
              >
                <div v-if="index === 0" class="cell_item " style="width:200px">
                  <span class="state_text">{{
                    itemDetail.state === 9 ? "成交" : "领先"
                  }}</span>
                </div>
                <div v-else class="cell_item " style="width:200px">
                  <span class="state_text">出局</span>
                </div>
                <div class="cell_item " style="width:300px">{{ item.phone }}</div>
                <div class="cell_item " style="width:315px">
                  {{ numTranFloat(item.bidPrice) }}
                </div>
                <div class="cell_item " style="width:362px">{{ item.createdAt }}</div>
              </div>
            </div>

            <div
              v-if="itemDetail.biddings && !itemDetail.biddings.length"
              class="x_y_center site_min_h"
            >
              <img src="@/assets/images/empty_icon.png" alt="" />
              <span style="margin: 0 0 0 10px">暂无数据</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <ImportJs :src="`${static_resource}/js/oss.js`" script-key="oss" @loadComplete="ossCompleteFn" />

  </div>

</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import construction from '@/components/template/targets/construction.vue'
import farmland from '@/components/template/targets/farmland.vue'
import house from '@/components/template/targets/house.vue'
import operating from '@/components/template/targets/operating.vue'
import resource from '@/components/template/targets/resource.vue'
import forest from '@/components/template/targets/forest.vue'
import wasteland from '@/components/template/targets/wasteland.vue'

import {
  debounce,
  regMobile,
  numTurnText,
  numTranFloat
} from '@/utils'

import {createPlayer ,filterRepeat,formatDate} from '@/utils'
import { user_playAuth } from "@/api/user";

import ImportJs from "@/components/base/ImportJs.vue";
import providers from "@/assets/js/chinatmsproviders";

export default {
  components: {
    ImportJs,
    construction,
    farmland,
    house,
    operating,
    resource,
    forest,
    wasteland,
  },
  props: {
    itemDetail: {
      type: Object,
      default: () => {}
    }

  },
  data() {
    return {
      initComplete:false,

      navHeadOffsetTop: 0, // 距离窗口顶部距离
      navHeadScrollTop: 0, // 滚动距离窗口顶部距离
      navHeadHeight: 0,

      firstTab: '',
      secondTab: '',
      thirdTab: '',
      fourthTab: '',
      fifthTab: '',
      sixthTab: '',

      firstActive: false,
      secondActive: false,
      thirdActive: false,
      fourthActive: false,
      fifthActive: false,
      sixthActive: false,

      allOtherAttachs:[],

      lMap: null, //标的位置地图实例
      layerMap: null, // 底图线路
      layerAnnotion: null, //底图文字
      tMap: null,
      geocoder: null,
      allMasterLnglats: [],
      polygonLayers: [],
      masterLayers: [],
      tMapType: "Satellite",
      currentTarget: null,  // 当前选中的标的信息
      currZoom: null,
      popupContent: {},
      formatted_address: null,
      currentMasterLayer: null,
      hasTargetLocation:false,

      targetVideoCheck: "pause",
      currentVideoIndex: null, // 当前hover视频索引
      player: null,
      playVideoIndex: null, // 正在播放视频索引

    }
  },
  computed: {
    ...mapGetters([
      'siteInfo',
      'Bucket_pub',
      'isMapJsComplete',
      'bidding',
      'tradeModeKey',
      'paymentModeKey',
      'delayKey',
      'whether',
      'auctionModeKey',
      'bidCountKey',
      'directionKey',
      'priceUnitKey',
      'static_resource'
    ]),
    formatDate() {
      return function (date, fmt) {
        return formatDate(new Date(date), fmt);
      };
    },

    // 隐藏手机号
    regMobile: function() {
      return function(phone) {
        return regMobile(phone)
      }
    },
    // 格式化金额（小数点）
    formatMoney: function () {
      return function (num) {
        return Number(num).toLocaleString();
      };
    },
    // 格式化金额（中文）
    numTurnText: function () {
      return function (num) {
        return numTurnText(num)
      };
    },
    projectInfo() {
      return this.itemDetail?.project || this.itemDetail
    },
    isActiveTab() {
      return this.navHeadScrollTop < 0
    },
    // 是否包含相关附件
    hasOtherAttachs() {
      return this.projectInfo.otherAttachs?.length
    },
    // 是否包含视频
    hasVideos() {
      return this.projectInfo.videos?.length
    },
    // 是否包含位置
    hasLocation() {
      for (const v of this.projectInfo.targets) {
        if ((v.gpsLat && v.gpsLng) || JSON.parse(v.layer)?.length) {
          return true
        }
      }
      return false
    },
    // 是竞价项目
    isAuction(){
      return this.projectInfo.tradeMode === 1
    },
    numTranFloat:function(){
      return function(num){
        return numTranFloat(num)
      }
    }
  },
  watch: {
    isMapJsComplete(n) {
      if (n) {
        this.handleIsCreateMap();
      }
    },
    tMapType(n) {
      this.addTiandituLayer(n);
    },
    siteInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.initBidding()
        }
      },
      immediate:true,
      deep:true,
    },
    projectInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.isMapJsComplete && !this.lMap && this.handleIsCreateMap();
          this.getAllOtherAttachs()
          this.$nextTick(() => {
            const navHead = this.$refs?.navHead
            this.navHeadHeight = Number(navHead.clientHeight)
            this.navHeadOffsetTop = Number(navHead.offsetTop)
            setTimeout(() => {
              this.initTabTitleRef()
            }, 0)
            window.onscroll = debounce(() => {
              this.firstTabActive()
              this.secondTabActive()
              this.thirdTabActive()
              this.fifthTabActive()
              this.fourthTabActive()
              this.sixthTabActive()
              this.navHeadScrollTop =
                this.navHeadOffsetTop - document.documentElement.scrollTop
            }, 10)
          })
        }
      },
      immediate:true,
      deep:true,
    },
  },
  mounted() {

  },
  destroyed() {
    window.onscroll = null
  },
  methods: {
    ...mapMutations({
      mapJsCompleteFn: "app/mapJsCompleteFn",
      ossCompleteFn: 'app/ossCompleteFn'
    }),
    ...mapActions({
      openPreviewFile: "upload/openPreviewFile",
      initBidding: 'cache/initBidding'
    }),

    // 播放，暂时按钮
    onPlayVideoClick(type, index) {
      this.onClosePlayer();
      if (type === "play") {
        this.initPlayer();
        this.playVideoIndex = index;
      }
      this.targetVideoCheck = type;
    },
    // 初始播放
    async initPlayer() {
      let data = await this.getVideoAuth(
        this.projectInfo.videos[this.currentVideoIndex]
      );

      this.player = await createPlayer(
        this.projectInfo.videos[this.currentVideoIndex],
        {
          id: "targetVideo_" + this.currentVideoIndex,
          playauth: data,
          width: "950px",
          height: "427px",
        }
      );

      // 播放完毕
      this.player.on("ended", (e) => {
        this.$set(this, "targetVideoCheck", "");
      });
    },
     // 获取视频播放凭证
     async getVideoAuth(video) {
      let { data } = await user_playAuth({ videoId: video.videoId });

      return data;
    },
    // 关闭播放器
    onClosePlayer() {
      try {
        this.player?.dispose(); // 销毁之前的播放器
        this.player = null;
        this.playVideoIndex = null;
      } catch (err) {
        console.log();
      }
    },
     //
     onTargetVideoEnter(index) {
      this.currentVideoIndex = index;
      console.log("currentVideoIndex", this.currentVideoIndex);
    },
     //
     onTargetVideoLeave() {
      this.currentVideoIndex = null;
    },

    // leaflet文件加载完成时执行
    leafletLoadComplete() {
      providers(L);
    },
    // 处理是否创建地图
    handleIsCreateMap() {
      setTimeout(() => {
          this.inittMap();
          this.initlMap();
        }, 0);
    },
    // 初始天地图实例
    inittMap() {
      this.tMap = new T.Map("tMap");
      this.geocoder = new T.Geocoder();
    },
    // 初始leaflet
    initlMap() {
      this.createlMap();
      this.addTiandituLayer();
      this.initTargetLocation();
    },
    // 创建地图实例
    createlMap() {
      this.lMap = new L.map("lMap", {
        center: [39.89945, 116.40969], //默认定位北京
        zoom: 12,
        minZoom: 5,
        maxZoom: 18,
        zoomControl: false,
        attributionControl: false,
      });

      // 绑定层级缩放结束事件
      this.lMap.addEventListener("zoomend", (e) => {
        this.currZoom = parseInt(this.lMap.getZoom());

        if (this.currZoom <= 14) {
          this.polygonLayers.map((i) =>
            i.polygon.setStyle({
              opacity: 0,
              fillOpacity: 0,
            })
          );
        } else {
          this.polygonLayers.map((i) =>
            i.polygon.setStyle({
              opacity: 1,
              fillOpacity: 0.2,
            })
          );
        }

        if (this.currZoom === 18) {
          setTimeout(() => {
            this.activePolygon();
          }, 100);
        }
      });
    },
    // 添加天地图瓦片
    addTiandituLayer() {
      //先移除原来的底图，否则会叠加
      this.layerMap?.remove();
      this.layerAnnotion?.remove();

      this.layerMap = L.tileLayer
        .chinaProvider(`TianDiTu.${this.tMapType}.Map`, {
          key: "723dd950fc4f69c37787ba1c4000dbdd",
        })
        .addTo(this.lMap); // 线路
      this.layerAnnotion = L.tileLayer
        .chinaProvider(`TianDiTu.${this.tMapType}.Annotion`, {
          key: "723dd950fc4f69c37787ba1c4000dbdd",
        })
        .addTo(this.lMap); // 文字
    },
    // 初始标的位置
    initTargetLocation() {
      this.polygonLayers = [];

      for (const v of this.projectInfo.targets) {
        if (v.gpsLat && v.gpsLng) {
          // 该标的有默认坐标
          this.allMasterLnglats.push([Number(v.gpsLat), Number(v.gpsLng)]);
          this.addMaster(new T.LngLat(v.gpsLng, v.gpsLat), v);
          this.initPolygonLayer(v.id, v.layer);
        } else if (v.layer) {
          //该标的有多边形
          this.computedCenterMass(v, JSON.parse(v.layer)[0]);
        }
      }

      this.addAllMasterEvent();
      // 如果所有标的都无坐标，多边形和详细地址，则根据项目所在地址定位
      if (
        !this.projectInfo.targets.every(
          (i) => (i.gpsLat && i.gpsLng) || i.address || i.layer
        )
      ) {
        this.geocoder.getPoint(
          this.projectInfo.area + this.projectInfo.address,
          (e) => {
            if (!e.location) return;

            const locationLnglat = new T.LngLat(
              e.location?.lon,
              e.location?.lat
            );
            this.lMap.setView(locationLnglat, 18);
          }
        );
      }

      this.allMasterLnglats.length &&
        this.lMap.fitBounds(this.allMasterLnglats); //填充的可视范围（点标记）
    },
    // 初始多边形（绘制）
    initPolygonLayer(targetId, latlngs) {
      if (latlngs && typeof latlngs === "string") {
        latlngs = JSON.parse(latlngs);
        if (!latlngs.length) return;
        this.addPolygonLayers(targetId, latlngs);
      }
    },
    // 回显多边形
    addPolygonLayers(targetId, latlngs) {
      let polygon;
      for (let v of latlngs) {
        polygon = L.polygon(v).addTo(this.lMap);
        this.polygonLayers.push({
          id: targetId,
          polygon: polygon,
        });
      }

      this.addAllPolygonEvent();
    },
    // 绑定所有多边形事件
    addAllPolygonEvent() {
      for (let v of this.polygonLayers) {
        v.polygon.removeEventListener("mouseover", this.mouseoverFn);
        v.polygon.removeEventListener("mouseout", this.mouseoutFn);
        v.polygon.addEventListener(
          "mouseover",
          this.mouseoverFn.bind(null, v.id)
        );
        v.polygon.addEventListener(
          "mouseout",
          this.mouseoutFn.bind(null, v.id)
        );
      }
    },
    // 计算多边形质心
    computedCenterMass(v, lnglats) {
      if (!lnglats) return;

      let polygons = [];
      if (lnglats.length > 1) {
        // 该多边形是多维
        for (const v of lnglats) {
          polygons.push(...v);
        }
      } else {
        polygons = JSON.parse(JSON.stringify(lnglats[0]));
      }

      polygons.push(polygons[0]); // 计算质心，第一项需要和最后一项相同

      const polygon = turf.polygon([polygons]);
      var { coordinates } = turf.centerOfMass(polygon).geometry;

      this.allMasterLnglats.push(coordinates);

      this.addPolygonLayers(v.id, [lnglats]);

      this.addMaster(new T.LngLat(coordinates[1], coordinates[0]), v); // 给多边形添加质心点标记
    },
    // 添加点标记
    addMaster(lnglat, v) {
      let master = null;
      master = L.marker(lnglat, {
        icon: L.icon({
          iconSize: [25, 41],
          iconAnchor: [13, 40],
          iconUrl: "http://api.tianditu.gov.cn/v4.0/image/marker-icon.png",
        }),
      });

      master.addTo(this.lMap);

      this.getMasterLocation(lnglat,v)

      this.saveMaster(v, master);
    },
    // 绑定所有点标记事件
    addAllMasterEvent() {
      for (let v of this.masterLayers) {
        v.master.removeEventListener("click", this.masterClick);
        v.master.addEventListener(
          "click",
          (e)=>this.masterClick(v.target,e)
        );
      }
    },
    // 保存点标记图层
    saveMaster(v, master) {
      this.masterLayers.push({
        target: v,
        master: master,
        id: v.id,
      });
      this.masterLayers = filterRepeat(this.masterLayers, "id");
    },
    // 点标记点击事件
    masterClick(target, e) {
      this.currentTarget = target;
      this.currentMasterLayer = e;

      // 跳转到对应位置
      this.setMasterView(e.latlng, 18);

      this.currZoom === 18 && this.activePolygon(); //点亮对应的多边形

      // 先显示默认地址，没有则根据已有坐标点获取；如果坐标点也没有，则根据点击事件参数获取
      if (target.address) {
        this.formatted_address = target.address;
      }else if (target.gpsLng) {
        this.getMasterLocation(T.LngLat(target.gpsLng, target.gpsLat),target);
      }else if (!target.gpsLng) {
        this.getMasterLocation(T.LngLat(e.latlng.lng, e.latlng.lat),target);
      }

    },
    // 设置点标记移动视图
    setMasterView(latlng, zoom) {
      if (this.currZoom === zoom) {
        this.lMap.setView(latlng, zoom, {
          duration: 2,
          noMoveStart: true,
        });
      } else {
        this.lMap.flyTo(latlng, zoom, {
          duration: 2,
          noMoveStart: true,
        });
      }
    },
    // 获取点标记位置
    getMasterLocation(lngLat,v) {
      this.formatted_address = "";
      this.geocoder.getLocation(lngLat, (e) => {
        this.formatted_address = e?.formatted_address;

        this.createPopup(lngLat,v.name,this.formatted_address)
      });
    },
    // 添加弹出窗口
    createPopup(latlng, title, address) {

      if (title || address) {
        L.popup({
          offset: L.point(0, -30),
          closeButton: false,
        })
          .setLatLng(latlng)
          .setContent(
            `<div style="width:247px">
                <div class="font_w_bold">${title}</div> <div class="fz12" style="color:#b4b4b4;margin:5px 0 0 0"> ${
              address || ""
            }</div>
            </div>`
          )
          .openOn(this.lMap);
      }
    },
    // 点亮多边形
    activePolygon() {
      if (!this.currentTarget) return;
      for (let v of this.polygonLayers) {
        if (v.id === this.currentTarget.id) {
          v.polygon.setStyle({
            color: "#4ae1aa",
            fillColor: "#5becb7",
          });
        } else {
          v.polygon.setStyle({
            color: "#3388ff",
            fillColor: "#3388ff",
          });
        }
      }
    },
    // 绑定多边形移入事件
    mouseoverFn(targetId, e) {
      for (let v of this.polygonLayers) {
        if (v.id === targetId) {
          v.polygon.setStyle({
            color: "#4ae1aa",
            fillColor: "#5becb7",
          });
        } else {
          v.polygon.setStyle({
            color: "#3388ff",
            fillColor: "#3388ff",
          });
        }
      }
    },
    // 绑定多边形移出事件
    mouseoutFn(targetId, e) {
      for (let v of this.polygonLayers) {
        v.polygon.setStyle({
          color: "#3388ff",
          fillColor: "#3388ff",
        });
      }
    },

    // 获取所有标的附件
    getAllOtherAttachs(){
      for (const v of this.projectInfo?.targets) {
        if (v?.otherAttachs?.length) {
          this.allOtherAttachs.push(...v?.otherAttachs);
        }
      }
      this.initComplete = true;
    },

    // 预览文件 click
    onFileClick(file) {
      window.open(file.url, '_blank')
    },

    // tab标的物激活
    firstTabActive() {
      if (!this.firstTab) return
      const top =
        this.firstTab.offsetTop -
        this.navHeadHeight -
        document.documentElement.scrollTop
      const bottom = top + this.firstTab.offsetHeight
      this.firstActive = top <= 5 && bottom >= 0
    },
    // tab相关附件激活
    secondTabActive() {
      if (!this.secondTab) return
      const top =
        this.secondTab.offsetTop -
        this.navHeadHeight -
        document.documentElement.scrollTop
      const bottom = top + this.secondTab.offsetHeight
      this.secondActive = top <= 0 && bottom >= 0
    },
    // tab标的视频激活
    thirdTabActive() {
      if (!this.thirdTab) return
      const top =
        this.thirdTab.offsetTop -
        this.navHeadHeight -
        document.documentElement.scrollTop
      const bottom = top + this.thirdTab.offsetHeight
      this.thirdActive = top <= 0 && bottom >= 0
    },
    // tab阅读须知激活
    fourthTabActive() {
      if (!this.fourthTab) return
      const top =
        this.fourthTab.offsetTop -
        this.navHeadHeight -
        document.documentElement.scrollTop
      const bottom = top + this.fourthTab.offsetHeight

      this.fourthActive = top <= 0 && bottom >= 0
    },
    // tab出价记录激活
    sixthTabActive() {
      if (!this.sixthTab) return
      const top =
        this.sixthTab.offsetTop -
        this.navHeadHeight -
        document.documentElement.scrollTop
      const bottom = top + this.sixthTab.offsetHeight
      this.sixthActive = top <= 0 && bottom >= 0
    },
    // tab标的位置激活
    fifthTabActive() {
      if (!this.fifthTab) return
      const top =
        this.fifthTab.offsetTop -
        this.navHeadHeight -
        document.documentElement.scrollTop
      const bottom = top + this.fifthTab.offsetHeight
      this.fifthActive = top <= 0 && bottom >= 0
    },
    // 点击tab项 click
    onTabAnchor(id) {
      window.scrollTo(0, this.$refs[id].offsetTop - 44)
    },
    // 获取tab标题dom
    initTabTitleRef() {
      this.firstTab = this.$refs.firstTab
      this.secondTab = this.$refs.secondTab
      this.thirdTab = this.$refs.thirdTab
      this.fourthTab = this.$refs.fourthTab
      this.fifthTab = this.$refs.fifthTab
      this.sixthTab = this.$refs.sixthTab
    }

  }
}
</script>

<style lang='scss' scoped>

::v-deep .leaflet-popup-content-wrapper {
  border-radius: 4px;
  .leaflet-popup-content {
    margin: 10px;
  }
}
::v-deep .leaflet-popup-tip {
  width: 12px;
  height: 12px;
}

.tab_nav_w {
  margin: 0 0 50px 0;
  padding-bottom: 50px;

}

::v-deep .tab_w {
    width: 876px;
    padding: 0 20px;
    .title_w {
      padding: 30px 0;
      font-size: 24px;
      & span {
        &:nth-child(2) {
          margin: 0 10px;
        }
      }
      .line {
        display: inline-block;
        width: 42px;
        height: 2px;
        background: #0983cc;
      }
    }
  }


  .tab_c_w {
    min-height: 700px;
    padding: 0;
  }

::v-deep .targets_w,::v-deep .table_info {
  & > table {
    width: 876px;
    // border-color: #e6e6e6;

    //标准单元格宽度
    .w_td {
      width: 147px;
    }
    //最大单元格宽度164
    .max_w_164 {
      max-width: 164px;
    }
    //最大单元格宽度210
    .max_w_210 {
      max-width: 210px;
    }
    //最大单元格宽度270
    .max_w_107 {
      max-width: 107px;
    }
    //最大单元格宽度696
    .max_w_696 {
      max-width: 696px;
    }

    &:last-child {
      border-bottom: 1px solid #e6e6e6;
    }
    tr {
      &:first-child {
        td {
          &:first-child {
            border-left: 1px solid #e6e6e6;
          }
        }
      }
      td {
        word-break: break-word;
        box-sizing: border-box;
        padding: 20px;
        border-top: 1px solid #e6e6e6;
        border-right: 1px solid #e6e6e6;
      }
    }
    .table_title {
      padding: 0 18px;
      box-sizing: border-box;
      width: 82px;
      line-height: 34px;
      font-size: 18px;
      background: #eaf2fa;
    }
  }
}
.location_w {
  margin: 50px 0 20px 0;
}
.nav_w {
  .nav_head {
    position: relative;
    // width: 917px;
    background: #f2f2f2;
    z-index: 403;
    border: 1px solid #e6e6e6;
    box-sizing: border-box;

    & li {
      width: 140px;
      text-align: center;
      cursor: pointer;
      border-right: 1px solid #e6e6e6;

      & .el-button {
        width: 140px;
        height: 46px;
        background-color: #f2f2f2;
        border: 0;
        &:active,
        &:focus {
          color: inherit;
          background-color: inherit;
        }
        &:hover{
          color: inherit;
        }
        &.is_active {
          background-color: #0983cc;
          color: #fff;
          border-color: #0983cc;
        }
      }
      &:last-child {
        border: 0;
      }
    }
  }
  .is_fixed {
    position: fixed;
    top: 0;
  }
}

.tab_content_w{
  padding: 0 0 20px 0;
  .second_tab{
  .attachs_item{
    margin-bottom: 5px;
  }
}
}

.map_w {
  position: relative;
  .map_options {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 401;
    ::v-deep .el-radio-button__inner {
      border-radius: 0;
    }
  }
}

.video_i {
    position: relative;
    width: 876px;
    height: 427px;
    margin: 0 auto 30px auto;
    &:last-child {
      margin: 0 auto;
    }
    .video_i_play_btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
      z-index: 1;
    }
  }

.realistic_picture_w {
  margin: 20px 0 0 0;
  .pic_i{
    width: 100%;
    margin: 0 0 30px 0;
    &:last-child{
      margin: 0;
    }
  }
}


.tab_w {

  .biddings_w {
    color: #1a1a1a;
    .state_text {
        width: 42px;
        height: 21px;
        padding: 0 3px;
        color: #1a1a1a;
        border: 1px solid #b3b3b3;
      }

    &:nth-child(1) {
      .state_text {
        padding: 2px 5px;
        border: 0;
        color: #fff;
        background-color: #cf3342;
      }
    }

    &:last-child {
      .cell_item {
        border-bottom: 0;
      }
    }
  }

  .cell_item {
    padding: 14px 0;
    border-bottom: 1px solid #e6e6e6;
  }

}
</style>
